export abstract class ApiService {}
